import { useContext } from 'react'
import { Typography, Link, Notification } from '@telus-uds/components-web'
import { string, shape } from 'prop-types'
import localeContext from '../../../../contexts/Locale'

const ResolvingOfferNotification = ({ resolvingOfferMessage: { bannerMessage, ctaUrl } }) => {
  const { lang } = useContext(localeContext)
  const splitBannerMessage = bannerMessage?.split('#')

  return (
    <Notification
      variant={{ validation: 'error' }}
      copy={lang}
      testID="resolving-offer-notification"
    >
      <Typography variant={{ size: 'medium' }} testID="resolving-offer-text">
        {splitBannerMessage?.[0]}
        <Link href={ctaUrl} variant="inline" size="small">
          {splitBannerMessage?.[1]}
        </Link>
        {splitBannerMessage?.[2]}
      </Typography>
    </Notification>
  )
}

ResolvingOfferNotification.propTypes = {
  resolvingOfferMessage: shape({
    bannerMessage: string.isRequired,
    ctaUrl: string.isRequired
  }).isRequired
}
export default ResolvingOfferNotification
